export default "__VITE_ASSET__abe764fd__"